<ng-container *transloco="let t">
  <div class="ui-input">
    @if (inputType === 'text' || inputType === 'digits') {
      @let isDigits = inputType === 'digits';
      <pxw-input-text
        [name]="customField.name"
        [label]="customField.name"
        [placeholder]="customField.name"
        [helper]="customField.legend"
        [required]="customField.required || false"
        [displayErrors]="displayErrors"
        [minLength]="customField.min"
        [maxLength]="customField.max"
        [pattern]="isDigits ? digitsPattern : undefined"
        [inputMode]="isDigits ? 'numeric' : 'text'"
        [messages]="{ pattern: t('validation.digitsOnly') }"
        [ngModel]="value"
        (ngModelChange)="onValueChanged($event)"
      />
    } @else if (inputType === 'number') {
      <pxw-input-number
        [name]="customField.name"
        [label]="customField.name"
        [placeholder]="customField.name"
        [helper]="customField.legend || null"
        [required]="customField.required || false"
        [displayErrors]="displayErrors"
        [min]="customField.min"
        [max]="customField.max"
        [ngModel]="value"
        (ngModelChange)="onValueChanged($event)"
      />
    } @else if (inputType === 'date') {
      <pxw-input-date
        [name]="customField.name"
        [label]="customField.name"
        [placeholder]="customField.name"
        [helper]="customField.legend || null"
        [required]="customField.required || false"
        [displayErrors]="displayErrors"
        [ngModel]="value"
        (ngModelChange)="onValueChanged($event)"
      />
    } @else if (inputType === 'select-box') {
      <pxw-select-box
        [name]="customField.name"
        [label]="customField.name"
        [options]="customField.options!"
        labelKey="value"
        valueKey="value"
        [helper]="customField.legend || null"
        [placeholder]="t('global.selectOption')"
        [required]="customField.required || false"
        [displayErrors]="displayErrors"
        [ngModel]="value"
        (ngModelChange)="onValueChanged($event)"
      />
    } @else if (inputType === 'checkboxes') {
      <pxw-input-checkbox-group
        [name]="customField.name"
        [label]="customField.name"
        [helper]="customField.legend || null"
        [options]="customField.options!"
        labelKey="value"
        valueKey="value"
        [required]="customField.required || false"
        [displayErrors]="displayErrors"
        [ngModel]="checkboxValues"
        (ngModelChange)="onValueChanged($event)"
      />
    }
  </div>
</ng-container>
